import { useState, useEffect } from "react";
import { getCuratedArticlesWidget } from "../api/widgets/curatedArticles/requests";

function useStoryblokCuratedArticlesWidget(articleIds) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCuratedArticlesWidget(articleIds)
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false))
  }, []);

  return [data, isLoading];
}

export { useStoryblokCuratedArticlesWidget };
